import React from 'react';
import CalendarPageTemplate from "../../../components/Templates/CalendarPageTemplate";
import {VerificationCenter_API} from "../VerificationCenterAPI";
import CalendarV2 from "./CalendarV2";

function Calendar() {
    const {getCalendar, addCalendarItem, deleteCalendarItem, updateCalendarItem} = VerificationCenter_API.calendar
    return (
        <CalendarV2/>
        // <CalendarPageTemplate
        //     getCalendarAPI={getCalendar()}
        //     addItemAPI={addCalendarItem}
        //     deleteItemAPI={deleteCalendarItem}
        //     updateItemAPI={updateCalendarItem}
        //
        //     calendarFormConf={
        //         {verificationCenter: false}
        //     }
        //
        //     breadCrumbsItems={[
        //         {title: 'Календарь'},
        //         {title: 'Все', actual: true,}]}
        // />
    )
}

export default Calendar;